// export const ASSET_PREFIX = '/@develop/samwarthika-ui/next';
export const ASSET_PREFIX = '';